<template lang="html">
  <div>
    <VqModal
      :name="modalName"
      class="vq-modal-add-edge">
      <template v-slot:header>
        <h2 class="modal-title">{{title}} <span class="is-bold">{{ $t('components.modalEditEdge.edge') }}</span></h2>
        <button
          type="button"
          class="button is-square is-rounded is-xsmall is-gray-100 modal-close"
          v-on:click="close">
          <span class="css-icon is-close"></span>
        </button>
      </template>
      <template v-slot:content>
        <div class="forms">
          <form>
            <div class="container has-separator">
              <div class="row">
                <VqSelect
                  classes="col-tab-12 pb-20"
                  name="type"
                  :label="$t('components.modalEditEdge.form.pool')"
                  option-label-attr="name"
                  option-value-attr="name"
                  :errors="errors.pool"
                  :options="pools"
                  :tooltip="c('add-edge:pool-tooltip')"
                  v-model="formData.pool"
                />
                <VqSelect
                  classes="col-tab-12 pb-20"
                  name="type"
                  :label="$t('components.modalEditEdge.form.type')"
                  option-label-attr="label"
                  option-value-attr="value"
                  :errors="errors.type"
                  :options="typeOptions"
                  :tooltip="c('add_edge:type-tooltip')"
                  v-model="formData.type"
                />
                <VqInput
                  classes="col-tab-12 pb-20"
                  :label="$t('components.modalEditEdge.form.bandwidth')"
                  name="Bandwidth"
                  type="number"
                  :errors="errors.bandwidth"
                  :min="10"
                  :max="1000"
                  :tooltip="c('add_edge:bandwidth-tooltip')"
                  v-model="formData.bandwidth"
                />
                <VqInput
                  classes="col-tab-12 pb-20"
                  :label="$t('components.modalEditEdge.form.name')"
                  name="Name"
                  type="text"
                  :errors="errors.name"
                  :min="0"
                  v-model="formData.name"
                />
                <VqInput
                  classes="col-tab-6 pb-20"
                  :label="$t('components.ModalAddPublicIp.form.ip_number')"
                  name="ip_nb"
                  type="number"
                  :errors="errors.ip_number"
                  :min="0"
                  :tooltip="c('add_edge:public_ip-tooltip')"
                  v-model="formData.ip_number"
                />
                <VqToggleBtn
                  classes="col-tab-3"
                  name="ha_option"
                  :label="$t('components.modalEditEdge.form.ha_option')"
                  :option-true="$t('components.modalEditPool.form.on')"
                  :option-false="$t('components.modalEditPool.form.off')"
                  v-model="formData.ha_option"
                  :tooltip="c('add_edge:ha_option-tooltip')"
                />
              </div>
            </div>
            <div class="container has-separator">
              <div class="row">
                <VqTextarea
                  classes="col-tab-12"
                  :label="$t('components.modalEditEdge.form.comment')"
                  name="comment"
                  :errors="errors.comment"
                  v-model="formData.comment"
                />
              </div>
            </div>

            <div class="container has-separator">
              <div class="row">
                <p class="is-danger">{{ $t('components.modalEditEdge.additionnal_charge') }}</p>
              </div>
            </div>
          </form>
        </div>
      </template>
      <template v-slot:footer>
        <button type="button" class="button is-small is-gray-400" v-on:click="close">{{ $t('components.modalEditEdge.form.cancel') }}</button>
        <div>
          <button
            v-if="$store.state.display_edit && $store.state.otrs_is_active"
            :class="{'is-loading': loading}"
            type="button"
            class="button is-small is-gamma"
            @click="submit">{{title}} {{ $t('components.modalEditEdge.edge') }}
          </button>
        </div>
      </template>
    </VqModal>
    <ModalVerificationCode
      v-if="isModalVerificationOpen"
      @verification-code="setVerification"
      @close-verification="closeVerification"/>
  </div>
</template>

<script lang="js">
import DIRECTOR from '@/api/director';

import { mapGetters } from 'vuex';
import { eventHubMixin } from '@/mixins/event';

import SUPPORT from '@/api/support';
import VqModal from '@/components/VqModal.vue';
import VqInput from '@/components/VqInput.vue';
import VqSelect from '@/components/VqSelect.vue';
import ModalVerificationCode from '@/components/ModalVerificationCode.vue';
import VqTextarea from '@/components/VqTextarea.vue';
import VqToggleBtn from '@/components/VqToggleBtn.vue';


export default {
  name: 'ModalAddEditEdge',
  mixins: [eventHubMixin],
  components: {
    VqModal,
    VqInput,
    VqSelect,
    ModalVerificationCode,
    VqTextarea,
    VqToggleBtn,
  },
  data() {
    return {
      modalName: 'add-edit-edge',
      pools: [],
      formData: {},
      errors: {},
      context: 'add',
      typeOptions: [
        {
          label: this.$t('components.modalEditEdge.config.compact'),
          value: 'compact',
        },
        {
          label: this.$t('components.modalEditEdge.config.full'),
          value: 'full',
        },
        {
          label: this.$t('components.modalEditEdge.config.full4'),
          value: 'full4',
        },
        {
          label: this.$t('components.modalEditEdge.config.xlarge'),
          value: 'xlarge',
        },
      ],
      isModalVerificationOpen: false,
      loading: false,
    };
  },
  filters: {
  },
  mounted() {
    if (this.hasDirectorAccess && this.viewingDirectorPages) {
      this.getPools();
    }
    this.onOpenModal(this.modalName, (data) => {
      this.initFormData();
      this.context = 'add';
      this.initFormErrors();
    });
  },
  methods: {
    getPools() {
      DIRECTOR.list().then(
        (res) => {
          if (res && res.data) {
            res.data.forEach((item) => {
              this.pools = this.pools.concat(item.pools);
            });
          }
        },
      );
    },
    close() {
      this.emitCloseModal(this.modalName);
    },

    initFormData() {
      this.formData = {
        pool: '',
        name: '',
        type: this.typeOptions[0].value,
        bandwidth: 10,
        ha_option: false,
        ip_number: 0,
        comment: '',
      };
    },

    initFormErrors() {
      this.errors = {
        pool: [],
        name: [],
        type: [],
        bandwidth: [],
        comment: [],
      };
    },

    setVerification(data) {
      this.isModalVerificationOpen = false;
      this.formData.verification_code = data;
      this.submit();
    },
    sendVerificationCode() {
      this.loading = true;
      SUPPORT.verification_code().then((res) => {
        this.isModalVerificationOpen = true;
      }),
      (err) => {
        Object.assign(this.errors, err.response.data);
      };
    },

    submit() {
      const method = this.context === 'add' ? 'addEdge' : 'editEdge';
      this.initFormErrors();
      SUPPORT[method](this.formData).then(() => {
        this.loading = false;
        this.initFormData();
        this.initFormErrors();
        this.close();
        this.addToast();
      },
      (err) => {
        Object.assign(this.errors, err.response.data);
        this.formData.verification_code = '';
        if (Object.keys(err.response.data).toString() === ['verification_code'].toString()) {
          this.sendVerificationCode();
        }
        if (err.response.status === 500) {
          this.emitAddToaster({
            title: this.$t('components.modalEditEdge.toasts.ticketError'),
            text: this.$t('components.modalEditEdge.toasts.ticketErrorContent'),
            state: 'danger',
          });
          this.close();
        }
      });
    },

    addToast() {
      this.emitAddToaster({
        title: this.$t('components.modalEditEdge.toasts.title'),
        text: this.$t('components.modalEditEdge.toasts.content'),
        state: 'success',
      });
    },

    closeVerification() {
      this.isModalVerificationOpen = false;
      this.loading = false;
    },

  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      hasDirectorAccess: 'auth/hasDirectorAccess',
      viewingDirectorPages: 'auth/viewingDirectorPages',
    }),
    title() {
      return this.$t('components.modalEditEdge.config.add');
    },
  },
};
</script>

<style scoped lang="scss">
.total-table {
  th {
    text-align: left;
  }
  td, th {
    padding: 5px;
  }
}
</style>
